let locales = {
    roleEdit_title: 'Create Role',
    roleEdit_titleEdit: 'Edit Role',
};

export default locales;